module.exports = __webpack_public_path__ + "static/media/icon_menu.801c8120.svg";